const useCookieModalStyles = (font, backgroundColor, applyConsumerHeadingFont = false) => {
    return {
        modal: { paddingBottom: '1rem' },
        header: {
            headerTitle: Object.assign(Object.assign({ fontSize: font.base.size.h2, fontWeight: font.base.weight.bold }, (!applyConsumerHeadingFont && { fontFamily: font.base.family })), { lineHeight: font.lineHeight.heading }),
            head: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
                marginBottom: '0.5rem'
            },
            title: Object.assign(Object.assign({ fontSize: font.base.size.h3 }, (!applyConsumerHeadingFont && { fontFamily: font.base.family })), { lineHeight: font.lineHeight.heading, marginLeft: '1rem' }),
            dismissButton: {
                alignSelf: 'right',
                marginRight: '1rem'
            },
            descriptionCollapsed: {
                fontSize: font.base.size.h5,
                fontFamily: font.base.family,
                lineHeight: font.lineHeight.heading,
                marginLeft: '1rem',
                marginRight: '1rem',
                marginTop: '0.5rem',
                maxHeight: '2.25rem',
                textOverflow: 'ellipsis',
                overflow: 'hidden'
            },
            descriptionExpanded: {
                fontSize: font.base.size.h5,
                fontFamily: font.base.family,
                lineHeight: font.lineHeight.heading,
                marginLeft: '1rem',
                marginRight: '1rem',
                marginTop: '0.5rem'
            }
        },
        body: {
            title: Object.assign(Object.assign({ fontSize: font.base.size.h5 }, (!applyConsumerHeadingFont && { fontFamily: font.base.family })), { fontWeight: font.base.weight.bold, lineHeight: font.lineHeight.heading, marginLeft: '-0.75rem', marginBottom: '0.125rem' }),
            statusGrey: {
                fontSize: font.base.size.h5,
                fontFamily: font.base.family,
                lineHeight: font.lineHeight.heading,
                color: font.color.soft,
                textAlign: 'right',
                marginLeft: '-2rem',
                marginRight: '-1rem',
                marginTop: '0.5rem',
                paddingRight: '1.5rem'
            },
            statusBlack: {
                fontSize: font.base.size.h5,
                fontFamily: font.base.family,
                lineHeight: font.lineHeight.heading,
                textAlign: 'right',
                marginLeft: '-0.5rem',
                marginRight: '-1rem',
                marginTop: '0.5rem',
                paddingRight: '1.5rem'
            },
            showHideLink: { fontSize: '12px', marginLeft: '-0.75rem' },
            bodyContainer: {
                marginTop: '1rem',
                marginBottom: '1rem',
                marginLeft: '3rem',
                marginRight: '3rem',
                width: 'fill'
            },
            privacyPolicyColumn: { paddingTop: '0.5rem' },
            privacyPolicyLink: { marginLeft: '0.4rem' },
            saveButtonColumn: { textAlign: 'right' },
            switch: {
                margin: '0.25rem -0.25rem 0.15rem 0rem'
            },
            contentCollapsed: {
                display: 'none'
            },
            contentExpanded: {
                width: 'fill',
                color: font.color.soft,
                fontSize: font.base.size.h5,
                fontFamily: font.base.family,
                lineHeight: font.lineHeight.heading,
                marginLeft: '-1.5rem',
                marginTop: '0.5rem',
                marginBottom: '0.5rem',
                overflow: 'hidden'
            },
            cookieCategorySectionWithBorder: {
                paddingTop: '1rem',
                paddingBottom: '1rem',
                paddingLeft: '0rem',
                borderBottom: `1px solid ${backgroundColor.active}`
            },
            cookieCategorySectionWithoutBorder: {
                paddingTop: '1rem',
                paddingBottom: '1rem',
                paddingLeft: '0rem'
            },
            showHideDescriptionLink: {
                fontSize: '12px',
                marginLeft: '1rem'
            }
        }
    };
};
export default useCookieModalStyles;
//# sourceMappingURL=cookieModalStyles.js.map